export default __webpack_public_path__ + "static/media/arrow_down.16b0d83d.svg";